import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";

const Navdata = () => {
    const history = useNavigate();
    const location = useLocation();
    const params = useParams();
    
    // State variables
    const [isDashboard, setIsDashboard] = useState(false);
    const [isProperties, setIsProperties] = useState(false);
    const [isRooms, setIsRooms] = useState(false);
    const [isBookings, setIsBookings] = useState(false);
    const [isUsers, setIsUsers] = useState(false);
    const [isDetailRoom, setIsDetailRoom] = useState(false);
    const [isVendors, setIsVendors] = useState(false);
    const [isReviews, setIsReviews] = useState(false);
    const [isAffiliates, setIsAffiliates] = useState(false);
    const [isFinance, setIsFinance] = useState(false);
    const [isSettings, setIsSettings] = useState(false);
    const [isPropertyDetails, setIsPropertyDetails] = useState(false);

     const propertyId = params.id || location.pathname.split('/')[2];

    const [iscurrentState, setIscurrentState] = useState('Dashboard');
    const [menuType, setMenuType] = useState('vendor');

    function updateIconSidebar(e: any) {
        if (e && e.target && e.target.getAttribute("sub-items")) {
            const ul: any = document.getElementById("two-column-menu");
            const iconItems = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");

                var id = item.getAttribute("sub-items");
                const getID = document.getElementById(id) as HTMLElement
                if (getID)
                    getID.classList.remove("show");
            });
        }
    }

    // Update menu type based on current path
    useEffect(() => {
        console.log('LayoutMenuData - Current path:', location.pathname);
        
        if (location.pathname.startsWith('/affiliate')) {
            console.log('Switching to affiliate menu');
            setMenuType('affiliate');
            // Reset all menu states when switching to affiliate
            setIsDashboard(false);
            setIsProperties(false);
            setIsRooms(false);
            setIsBookings(false);
            setIsReviews(false);
            setIsFinance(false);
            setIsSettings(false);
        } else if (location.pathname.startsWith('/propertiesDetails')) {
            console.log('Switching to properties menu');
            setMenuType('properties');
            // Reset all menu states when switching to properties
            setIsDashboard(false);
            setIsProperties(false);
            setIsRooms(false);
            setIsBookings(false);
            setIsReviews(false);
            setIsFinance(false);
            setIsSettings(false);
        } else {
            console.log('Switching to vendor menu');
            setMenuType('vendor');
        }
        
        console.log('Menu type set to:', menuType);
    }, [location.pathname]);

    // Reset menu states when needed
    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');

        if (location.pathname.includes('/details/')) {
            setIsPropertyDetails(true);
            setIscurrentState('Property details');
        }

        if (location.pathname.includes('/rooms/')) {
            setIsDetailRoom(true);
            setIscurrentState('Rooms and rates');
        }
        
        if (iscurrentState !== 'Dashboard') {
            setIsDashboard(false);
        }
        if (iscurrentState !== 'Properties') {
            setIsProperties(false);
            setIsRooms(false);
        }
        if (iscurrentState !== 'Bookings') {
            setIsBookings(false);
        }
        if (iscurrentState !== 'Reviews') {
            setIsReviews(false);
        }
        if (iscurrentState !== 'Finance') {
            setIsFinance(false);
        }
        if (iscurrentState !== 'Settings') {
            setIsSettings(false);
        }
    }, [
        location.pathname,
        history,
        iscurrentState,
        isDashboard,
        isProperties,
        isRooms,
        isBookings,
        isReviews,
        isFinance,
        isSettings
    ]);

    // Affiliate menu items
    const affiliateMenuItems: any = [
        {
            id: "affiliate-dashboard",
            label: "Dashboard",
            icon: "ri-dashboard-2-line",
            link: "/affiliate/dashboard",
            parentId: "affiliate",
        },
        {
            id: "affiliate-report",
            label: "Report",
            icon: "ri-file-chart-line",
            link: "/affiliate/report",
            parentId: "affiliate",
        },
        {
            id: "affiliate-commission",
            label: "Commission",
            icon: "ri-money-dollar-circle-line",
            link: "/affiliate/commission",
            parentId: "affiliate",
        },
        {
            id: "affiliate-history",
            label: "History",
            icon: "ri-history-line",
            link: "/affiliate/history",
            parentId: "affiliate",
        },
        {
            id: "affiliate-link",
            label: "Affiliate Link",
            icon: "ri-link",
            link: "/affiliate/link",
            parentId: "affiliate",
        },
    ];

    // Vendor menu items
    const vendorMenuItems: any = [
        {
            id: "dashboard",
            label: "Dashboard",
            icon: "ri-dashboard-2-line",
            link: "/#",
            stateVariables: isDashboard,
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState('Dashboard');
                updateIconSidebar(e);
            },
            subItems: [
                { id: "overview", label: "Overview", link: "/dashboard", parentId: "dashboard" },
            ],
        },
        {
            id: "properties",
            label: "Properties",
            icon: "ri-building-line",
            link: "/#",
            stateVariables: isProperties,
            click: function (e: any) {
                e.preventDefault();
                setIsProperties(!isProperties);
                setIscurrentState('Properties');
                updateIconSidebar(e);
            },
            subItems: [
                {
                    id: "allProperties",
                    label: "All Properties",
                    link: "/allproperties",
                    parentId: "properties",
                },
                {
                    id: "addProperty",
                    label: "Add Property",
                    link: "/properties/add",
                    parentId: "properties",
                },
                {
                    id: "pendingProperties",
                    label: "Pending Approval",
                    link: "/pendingApproval",
                    parentId: "properties",
                },
            ],
        },
        {
            id: "bookings",
            label: "Reservations",
            icon: "ri-calendar-check-line",
            link: "/#",
            stateVariables: isBookings,
            click: function (e: any) {
                e.preventDefault();
                setIsBookings(!isBookings);
                setIscurrentState('Bookings');
                updateIconSidebar(e);
            },
            subItems: [
                { id: "allBookings", label: "All Reservations", link: "/allReservations", parentId: "bookings" },
               
            ],
        },
         {
            id: "finance",
            label: "Finance",
            icon: "ri-money-dollar-circle-line",
            link: "/#",
            stateVariables: isFinance,
            click: function (e: any) {
                e.preventDefault();
                setIsFinance(!isFinance);
                setIscurrentState('Finance');
                updateIconSidebar(e);
            },
            subItems: [
                { id: "payments", label: "Payments", link: "/allPayments", parentId: "finance" },
                // { id: "revenue", label: "Revenue Reports", link: "/allRevenue", parentId: "finance" },
                
            ],
        },
        /**
        {
            id: "reviews",
            label: "Reviews",
            icon: "ri-star-line",
            link: "/#",
            stateVariables: isReviews,
            click: function (e: any) {
                e.preventDefault();
                setIsReviews(!isReviews);
                setIscurrentState('Reviews');
                updateIconSidebar(e);
            },
            subItems: [
                { id: "allReviews", label: "All Reviews", link: "/reviews", parentId: "reviews" },
                { id: "pendingReviews", label: "Pending Approval", link: "/reviews/pending", parentId: "reviews" },
                { id: "approvedReviews", label: "Approved", link: "/reviews/approved", parentId: "reviews" },
                { id: "rejectedReviews", label: "Rejected", link: "/reviews/rejected", parentId: "reviews" }
            ],
        },
         */
       
        /** 
        {
            id: "settings",
            label: "Settings",
            icon: "ri-settings-3-line",
            link: "/#",
            stateVariables: isSettings,
            click: function (e: any) {
                e.preventDefault();
                setIsSettings(!isSettings);
                setIscurrentState('Settings');
                updateIconSidebar(e);
            },
            subItems: [
                { id: "general", label: "General", link: "/settings/general", parentId: "settings" },
                { id: "notifications", label: "Notifications", link: "/settings/notifications", parentId: "settings" },
                { id: "security", label: "Security", link: "/settings/security", parentId: "settings" },
                { id: "backup", label: "Backup", link: "/settings/backup", parentId: "settings" }
            ],
        },
        */
    ];

    // Property details menu
    const propertiesMenuItems: any = [
        {
            id: "home",
            label: "Home",
            icon: "ri-home-4-line",
            link: `/propertiesDetails/${propertyId}`,
            exactMatch: true,
        },
        {
            id: "properties-rooms-rates",
            label: "Rooms and rates",
            icon: "ri-hotel-bed-line",
            link: `/propertiesDetails/${propertyId}/rooms`,
            stateVariables: isDetailRoom,
            click: function (e: any) {
                e.preventDefault();
                setIsDetailRoom(!isDetailRoom);
                setIscurrentState('Rooms and rates');
                updateIconSidebar(e);
            },
            subItems: [
                { 
                    id: "rates-availability", 
                    label: "Rates and availability", 
                    link: `/propertiesDetails/${propertyId}/rooms/rates-availability`, 
                    parentId: "properties-rooms-rates" 
                },
                { 
                    id: "room-types", 
                    label: "Room types and rate plans", 
                    link: `/propertiesDetails/${propertyId}/rooms/rates-types`, 
                    parentId: "properties-rooms-rates" 
                },
                //{ 
                    //id: "bulk-inventory-availability", 
                    //label: "Bulk inventory and availability", 
                    //link: `/propertiesDetails/${propertyId}/rooms/bulk-inventory`, 
                    //parentId: "properties-rooms-rates" 
                //},
                //{ 
                    //id: "bulk-rates-restrictions", 
                    //label: "Bulk Rates and Restrictions", 
                    //link: `/propertiesDetails/${propertyId}/rooms/bulk-rates`, 
                    //parentId: "properties-rooms-rates" 
                //},
                { 
                    id: "cancellation-policies", 
                    label: "Cancellation policies", 
                    link: `/propertiesDetails/${propertyId}/rooms/cancellation-policies`, 
                    parentId: "properties-rooms-rates" 
                },
            ],
            exactMatch: true,
        },
        {
            id: "reservations",
            label: "Reservations",
            icon: "ri-calendar-check-line",
            link: `/propertiesDetails/${propertyId}/reservations`,
            exactMatch: true,
        },
        {
            id: "payments",
            label: "Payments",
            icon: "ri-bank-card-line",
            link: `/propertiesDetails/${propertyId}/payments`,
            exactMatch: true,
        },
        {
            id: "property-details",
            label: "Property details",
            icon: "ri-building-line",
            link: `/propertiesDetails/${propertyId}/details`,
            stateVariables: isPropertyDetails,
            click: function (e: any) {
                e.preventDefault();
                setIsPropertyDetails(!isPropertyDetails);
                setIscurrentState('Property details');
                updateIconSidebar(e);
            },
            subItems: [
                 { 
                    id: "overview", 
                    label: "Overview", 
                    link: `/propertiesDetails/${propertyId}/details/overview`, 
                    parentId: "property-details" 
                },
                 //{ 
                    //id: "property-admin", 
                    //label: "Property Administration", 
                    //link: `/propertiesDetails/${propertyId}/details/administration`, 
                    //parentId: "property-details" 
                //},
                 { 
                    id: "property-photos", 
                    label: "Photos", 
                    link: `/propertiesDetails/${propertyId}/details/photos`, 
                    parentId: "property-details" 
                },
                 { 
                    id: "property-amenities", 
                    label: "Property Amenities", 
                    link: `/propertiesDetails/${propertyId}/details/amenities`, 
                    parentId: "property-details" 
                },
                 { 
                    id: "property-room-amenities", 
                    label: "Room Amenities", 
                    link: `/propertiesDetails/${propertyId}/details/room-amenities`, 
                    parentId: "property-details" 
                },
                 {
                    id: "property-taxes-fees",
                    label: "Taxes & fees",
                    link: `/propertiesDetails/${propertyId}/details/taxes-fees`,
                    parentId: "property-details"
                },
            ],
            exactMatch: true,
        },
        // {
        //     id: "revenue",
        //     label: "Revenue management",
        //     icon: "ri-line-chart-line",
        //     link: `/propertiesDetails/${propertyId}/revenue-management`,
        //     exactMatch: true,
        // },
        {
            id: "all-properties",
            label: "View all properties",
            icon: "ri-building-2-line",
            link: `/allproperties`,
            exactMatch: true,
        },
       
    ];;

    // Select menu items based on current menu type
    const menuItems = menuType === 'affiliate' 
        ? affiliateMenuItems
        : menuType === 'properties'
        ? propertiesMenuItems
        : vendorMenuItems;
    
    console.log('Returning menu items for type:', menuType, 'Count:', menuItems.length);
    
    return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;
